export default "__VITE_ASSET__D2v4Aij4__"